// extracted by mini-css-extract-plugin
module.exports = {"locationListTable":"locations_locationListTable__1CzLH","status":"locations_status__c4W_K"};